import { Component, OnInit } from '@angular/core';

import { Campus } from 'src/app/core/models/api/campus.model';
import { CampusService } from 'src/app/core/services/api/campus.service';

@Component({
    selector: 'app-goals',
    templateUrl: './goals.component.html',
    styleUrls: ['./goals.component.scss']
})
export class GoalsComponent implements OnInit {
    
    public campus: Campus;
    public webResourceId: string = "goals-page";

    constructor(private campusService: CampusService) { }

    ngOnInit() {
        this.campus = this.campusService.campusActive;
    }

}
